/**
 * @file Photo pricings related fragments.
 */

import gql from 'graphql-tag';

export const PhotoPricingDetails = gql`
  fragment PhotoPricingDetails on PhotoPricing {
    id
    name
    requires_package_purchase
    digital_downloads_price {
      value
      currency
    }
    print_items(slice: { limit: 9999 }) {
      total
      records {
        id
        price {
          value
          currency
        }
        type {
          id
          name
          min_price {
            value
            currency
          }
        }
      }
    }
    print_product_items(slice: { limit: 9999 }) {
      total
      records {
        id
        print_product {
          id
          name
        }
        print_product_size {
          id
          print_size {
            id
            name
          }
          price {
            value
            currency
          }
          min_price {
            value
            currency
          }
        }
        price {
          value
          currency
        }
      }
    }
    print_partner {
      id
    }
  }
`;

export const AlbumPhotoPricingDetails = gql`
  fragment AlbumPhotoPricingDetails on PhotoPricing {
    id
    albums {
      records {
        id
        name
      }
    }
  }
`;
